import CustomAxios from "..";

// Upload workout
export const uploadSingleWorkout = async (formData, fileName) => {
  try {
    const response = await CustomAxios.post(
      `/plans/workout/json?fileName=${encodeURIComponent(fileName)}`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return response.data;
  } catch (error) {
    console.error("Error uploading plan:", error?.response?.data || error.message);
    throw new Error(error?.response?.data?.message || "Failed to upload workout plan.");
  }
};


export const deleteSingleWorkoutById = async (id) => {
  try {
    const response = await CustomAxios.delete(`/plans/workout/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching plan:", error.message || error);
    throw new Error("Failed to retrieve the plan. Please try again.");
  }
};

// Update workout by ID
export const updateSingleWorkout = async (id, formData, fileName) => {
  try {
    const response = await CustomAxios.put(
      `/plans/workout/${id}?fileName=${encodeURIComponent(fileName)}`,
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating plan:", error?.response?.data || error.message);
    throw new Error(error?.response?.data?.message || "Failed to update workout plan.");
  }
};

// Get single workout by ID
export const getSingleWorkoutById = async (id) => {
  try {
    const response = await CustomAxios.get(`/plans/workout/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching plan:", error?.response?.data || error.message);
    throw new Error("Failed to retrieve the plan. Please try again.");
  }
};

// Get all workouts
export const getAllSingleWorkOut = async (params={}) => {
  try {
    const response = await CustomAxios.get(`/plans/workout`,{params});
    return response.data;
  } catch (error) {
    console.error("Error fetching workouts:", error?.response?.data || error.message);
    throw new Error("Failed to retrieve all workout plans.");
  }
};

// Get workout plans by tag
export const getSinglePlansByTag = async (planTag) => {
  try {
    const response = await CustomAxios.get(`/plans/tag/${encodeURIComponent(planTag)}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching plans with tag "${planTag}":`, error?.response?.data || error.message);
    throw new Error("Failed to retrieve the plans by tag. Please try again.");
  }
};
